import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

type SendTestPushParams = {
  artistId: string;
  campaignId: string;
  /**
   * Public user ids. Omit to test on your own account — naming other accounts is Pray staff only and the
   * API rejects it for everyone else. Ids come from the member search, so no email or phone is sent here.
   */
  userIds?: string[];
};

export type TestPushRecipient = {
  user_id: string;
  name: string | null;
};

export async function sendTestPush({ artistId, campaignId, userIds }: SendTestPushParams) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!campaignId) throw new Error('Campaign ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/push/${campaignId}/test-push`;
  const response = await api.executePostRequest<ObjectResponse<{ recipients: TestPushRecipient[] }>>(
    url,
    userIds?.length ? { user_ids: userIds } : {},
  );

  return response.data?.data?.recipients ?? [];
}
